<template>
  <div class="product-search">
    <TextBox
      v-model="query"
      :label="labels.get('Product Search Placeholder')"
      ref="searchBox"
    ></TextBox>
    <div class="products-container">
      <div v-for="p in products" :key="p.id" class="product-wrapper">
        <RadioButton
          v-model="currentProduct"
          :value="p.id"
          @change="onChange(p)"
        ></RadioButton>
        <ProductCard :product="p"></ProductCard>
      </div>
    </div>
    <div class="no-products" v-if="showNoProductsMsg">{{labels.get('No products found')}}</div>
  </div>
</template>

<script>
import ServiceManager from "../services/service-manager";
import ProductCard from "./ProductCard.vue";
import { RadioButton, TextBox } from "clariant-vue3-forms";

export default {
  name: "ProductSearch",
  components: {
    ProductCard,
    RadioButton,
    TextBox,
  },
  props: ["sample-available"],
  data() {
    return {
      labels: ServiceManager.getService(this, "Labels"),
      utils: ServiceManager.getService(this, "Utils"),
      dataLayer: ServiceManager.getService(this, "DataLayer"),
      products: [],
      currentProduct: null,
      query: "",
      showNoProductsMsg: false
    };
  },
  mounted() {
    if (this.$refs.searchBox) {
      let input = this.$refs.searchBox.$el.querySelector(
        ".input-container > input"
      );
      if (input) {
        input.addEventListener("keyup", this.onKeyUp);
        input.focus();
      }
    }
  },
  beforeUnmount() {
    if (this.$refs.searchBox) {
      let input = this.$refs.searchBox.$el.querySelector(
        ".input-container > input"
      );
      if (input) {
        input.removeEventListener("keyup", this.onKeyUp);
      }
    }
  },
  methods: {
    onChange(p) {
      this.$emit("change", p);
    },
    loadProducts() {
      this.products = [];
      let query = this.getQuery();
      if (!query)  {
        this.showNoProductsMsg = false;
        return;
      }
      console.log(`Loading products for ${query}`);
      let loader = this.utils.showLoader(".product-search");
      this.dataLayer.loadProducts(
        query,
        typeof this.sampleAvailable !== "undefined" &&
          this.sampleAvailable !== "false"
      )
        .then((res) => {
          this.products = res.data;
        })
        .catch((err) => {
          this.utils.showStatusMessage(
            `Could not load products. Error: ${err.message}.`,
            "red"
          );
        })
        .finally(() => {
          this.utils.removeLoader(loader);
          this.showNoProductsMsg = query && this.products.length === 0;
        });
    },
    getQuery() {
      let input = this.$refs.searchBox.$el.querySelector(
        ".input-container > input"
      );
      if (input) {
        return input.value;
      }
      return "";
    },
    onKeyUp(e) {
      let self = this;
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        self.loadProducts();
      }, 300);
    },
  },
};
</script>

<style scoped>
.product-wrapper {
  display: flex;
  margin: 10px 0;
  align-items: center;
}
.product-search {
  position: relative;
  min-height: 300px;
}
.products-container {
  max-height: 420px;
  overflow-y: auto;
}
</style>
